import { createReducer } from 'redux-starter-kit';
import {
  fetchAddEmailRecipient, fetchEmailRecipients, editEmailRecipient, cancelEditEmailRecipient
} from './emailRecipientsUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';

/**
 * A selector for finding the current email recipient edit state.
 * @param {object} state The redux state for the application.
 * @returns An object containing details about the email recipient being edited.
 * @example const editState = selectEditState(state);
 */
export const selectEditState = state => state.via.ui.emailRecipients.editState;

/**
 * A selector that returns the state of the request to retrieve all email recipients action.
 * @param {object} state The redux state for the application.
 * @return An object representing the request state.
 * @example const fetchRecipientsRequest = selectRecipientsRequest(state);
 */
export const selectEmailRecipientsRequest = (state) => {
  const requestId = state.via.ui.emailRecipients.requestEmailRecipientId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for the current 'request to create a new email recipient ' request.
 * @param {object} state The redux state for the application.
 * @returns An object representing the request state.
 * @example const createEmailRecipientRequest = selectCreateEmailRecipientRequest(state);
 */
export const selectCreateEmailRecipientRequest = (state) => {
  const requestId = state.via.ui.emailRecipients.editState.requestCreateEmailRecipientId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialEditingState = {
  isEditing: false,
  emailAddress: null,
  requestCreateEmailRecipientId: null,
  validationMessages: ({
    title: '',
    messages: [],
    visible: false,
  }),
};

const emailRecipientsInitialState = {
  editState: initialEditingState,
  requestEmailRecipientId: null,
};

/**
 * A reducer for handling the UI state changes for the Email Recipients Configuration screen.
 */
const emailRecipientUiReducer = createReducer(emailRecipientsInitialState, {

  [editEmailRecipient]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      isEditing: true,
      recipientId: action.payload,
    },
  }),

  // A user is no longer being edited
  [cancelEditEmailRecipient]: state => ({
    ...state,
    editState: {
      ...initialEditingState,
    },
  }),

  // A new requst has been made to add an email recipient
  [fetchAddEmailRecipient]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      requestCreateEmailRecipientId: action.payload,
    },
  }),

  // A new request has been made to load all the email recipients from the platform
  [fetchEmailRecipients]: (state, action) => ({
    ...state,
    requestEmailRecipientId: action.payload,
  }),
});

export default emailRecipientUiReducer;
